<template>
    <button class="btn btn-outline-gray btn-sm is-border-1" @click="exportCall">
        <i class="icon12-export-primary icon-left"></i>{{$t('export')}}
        <b-modal v-model="exporting" :title="$t('exportingData')" @close="close" no-close-on-esc no-close-on-backdrop no-enforce-focus>
            <div class="alert alert-warning">
                <b-spinner small variant="primary"></b-spinner>&nbsp;
                <span>{{$t('exportNotice')}}</span>
            </div>
        </b-modal>
    </button>
</template>
<script>
import {saveAs} from 'file-saver';
import Excel from 'exceljs';
import moment from 'moment';
export default {
    props: ['data','filter'],
    data() {
        return {
            exporting: false
        }
    },
    methods: {
        close(evt) {
            if (this.exporting) {
                evt.preventDefault();
            } else {
                this.exporting = false;
            }
            this.downloadedCount = 0;
        },
        setupSheet: function (sheet) {
            let cols = [
                {key: 'item', width: 20},
                {key: 'total', width: 20},
                {key: 'success', width: 15},
                {key: 'busy', width: 15},
                {key: 'rejected', width: 15},
                {key: 'invalidNumber', width: 15},
                {key: 'networkBusy', width: 15},
                {key: 'agentNetworkFail', width: 15},
                {key: 'other', width: 15},
                {key: 'missCall', width: 15},
                {key: 'talkingTime', width: 15},
                {key: 'waitingTime', width: 15},
                {key: 'averageCallTime', width: 15},
            ];
            let row = {
                item: this.$t(''),
                total: this.$t("totalCount"),
                success: this.$t("successCount"),
                busy: this.$t("busyCount"),
                rejected: this.$t("rejectedCount"),
                invalidNumber: this.$t("invalidNumberCount"),
                networkBusy: this.$t("networkBusyCount"),
                agentNetworkFail: this.$t('agentNetworkFailCount'),
                other: this.$t('othersCount'),
                missCall: this.$t('missCall'),
                talkingTime: this.$t('talkingTime'),
                waitingTime: this.$t('waitingTime'),
                averageCallTime: this.$t('averageCallTime'),

            };
            sheet.columns = cols;
            sheet.addRow(row);
            let row2 = {}
            this.data.forEach((item) => {
                for(let key in item){
                    if(!row2[key]){
                        row2[key] = 0;
                    }
                row2[key] += item[key];
                }
                
            });
            
            row2.talkingTime = row2.billDuration? row2.billDuration : '';
            row2.waitingTime = row2.duration - row2.billDuration ? row2.duration - row2.billDuration : '';
            row2.averageCallTime = Math.round(row2.billDuration/row2.success);
            let row3 = {};
            for(let key in row2){
                row3[key] = Math.round(row2[key] / this.data.length);
            }
            row2.item = this.$t('totals');
            row3.item = this.$t('average');
            sheet.addRow(row2);
            sheet.addRow(row3);

        },
        exportCall() {
            this.exporting = true;
            let workbook = new Excel.Workbook();
            let sheet = workbook.addWorksheet('data');
            this.setupSheet(sheet);
            do {
                this.data.forEach(item => {
                    let row = {
                        item: item.label ? item.label : moment(this.filter.from + item._id, 'x').format('DD/MM/YYYY'),
                        total: item.total ? item.total : '',
                        success: item.success ? item.success : '',
                        busy: item.busy ? item.busy : '',
                        rejected: item.rejected ? item.rejected : '',
                        invalidNumber: item.invalidNumber ? item.invalidNumber : '',
                        networkBusy: item.networkBusy ? item.networkBusy : '',
                        agentNetworkFail: item.agentNetworkFail ? item.agentNetworkFail : '',
                        other: item.other ? item.other : '',
                        missCall: item.missCall ? item.missCall : '',
                        talkingTime: item.billDuration ? item.billDuration : '',
                        waitingTime: item.duration - item.billDuration ? item.duration - item.billDuration : '',
                        averageCallTime: item.success > 0 ? Math.round((item.billDuration/item.success)) : 0,
                        
                        
                    };
                    sheet.addRow(row);
                });
            } while (this.data && this.data.hasNextPage);

            workbook.xlsx.writeBuffer({base64: true}).then(data => {
                this.exporting = false;
                saveAs(new Blob([data], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'}),
                    'call-report.xlsx');
            });
        },
    }
}
</script>